<nz-layout>
  <!-- Desktop sidebar -->
  <nz-sider
    nzCollapsible
    [(nzCollapsed)]="collapse"
    nzWidth="225px"
    class="scrollbar"
    [nzTrigger]="null"
    *ngIf="!isMobile()"
  >
    <div class="icon_menu" [ngClass]="collapse ? 'menu-center' : ''">
      <span class="trigger" nz-icon [nzType]="collapse ? 'menu-unfold' : 'menu-fold'" (click)="changeCollapse()"></span>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline">
      <ng-container *ngFor="let item of menus">
        <li
          *ngIf="!item.children && item.title != this.recalculation?.label"
          nz-menu-item
          routerLink="{{ item.url }}"
          [nzSelected]="item.id === menuSelected.id"
          (click)="checkRouter(item, false)"
        >
          <i nz-icon [nzType]="item.icon"></i>
          <span>{{ item.title }}</span>
          <i *ngIf="item.external" nz-icon nzType="export" style="font-size:11px;margin-left:4px;opacity:0.5;"></i>
        </li>
        <li
          *ngIf="item.children"
          nz-submenu
          nzTitle="{{ item.title }}"
          nzIcon="{{ item.icon }}"
          [(nzOpen)]="item.openSubMenu"
          (nzOpenChange)="openSubHandler(item)"
        >
          <ul>
            <li
              *ngFor="let itemSub of item.children"
              nz-menu-item
              style="padding-left: 40px !important;"
              routerLink="{{ itemSub.url }}"
              [nzSelected]="itemSub.id === menuSelected.id"
              (click)="checkRouter(itemSub, true)"
            >
              {{ itemSub.title }}
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </nz-sider>

  <!-- Content -->
  <nz-layout>

    <!-- Mobile top bar -->
    <div class="mobile-topbar" *ngIf="isMobile()">
      <button class="hamburger-btn" (click)="openDrawer()">
        <i nz-icon nzType="menu" style="font-size: 20px;"></i>
      </button>
      <span class="mobile-app-title">Fox Sports</span>
      <div style="width: 40px;"></div>
    </div>

    <nz-header *ngIf="!isMobile()">
      <app-header></app-header>
    </nz-header>

    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>

<!-- Mobile drawer -->
<nz-drawer
  [nzVisible]="drawerVisible"
  nzPlacement="left"
  nzTitle="Fox Sports"
  nzWidth="280px"
  (nzOnClose)="closeDrawer()"
>
  <ng-container *nzDrawerContent>
    <ul class="mobile-menu-list">
      <ng-container *ngFor="let item of menus">

        <!-- Item không có children -->
        <li
          *ngIf="!item.children"
          class="mobile-menu-item"
          [class.active]="item.id === menuSelected.id"
          (click)="navigateMobile(item)"
        >
          <i nz-icon [nzType]="item.icon" class="menu-icon"></i>
          <span>{{ item.title }}</span>
          <i *ngIf="item.external" nz-icon nzType="export" style="font-size:11px;margin-left:auto;opacity:0.4;"></i>
        </li>

        <!-- Item có children: hiện group -->
        <li *ngIf="item.children" class="mobile-menu-group">
          <div class="mobile-menu-group-title">
            <i nz-icon [nzType]="item.icon" class="menu-icon"></i>
            <span>{{ item.title }}</span>
          </div>
          <ul class="mobile-menu-children">
            <li
              *ngFor="let sub of item.children"
              class="mobile-menu-item mobile-menu-child"
              [class.active]="sub.id === menuSelected.id"
              (click)="navigateMobile(sub, true)"
            >
              <i nz-icon [nzType]="sub.icon" class="menu-icon"></i>
              <span>{{ sub.title }}</span>
            </li>
          </ul>
        </li>

      </ng-container>
    </ul>
  </ng-container>
</nz-drawer>
